import Phaser, {
   Display
} from 'phaser'
import gsap from "gsap";
//*** VARIABLES ***/
let gameScale;

let guide;
let guideAnimate;
let flaxGS;
let flax1;
let flax2;
let flax3;
let flax4;
let wholeWorld;
let worldGS;
let arrow;

let next;
let sounds;
let utils;
let _this;
let xmlLoader;

export default class Intro extends Phaser.Scene {
   constructor() {
      super('intro')
   }

   preload() {
      gameScale = this.registry.values.scaleIt;
   }

   create() {
      _this = this;
      sounds = this.scene.get('sounds');
      utils = this.scene.get('utils');
      flax1 = utils.addImage(this, {
         x: 150,
         y: 850,
         id: 'flax1',
         originX: 0.5,
         originY: 1
      });

      flax2 = utils.addImage(this, {
         x: 650,
         y: 850,
         id: 'flax1',
         originX: 0.5,
         originY: 1,
         flip: true
      });

      flax3 = utils.addImage(this, {
         x: 200,
         y: 800,
         id: 'flax1',
         originX: 0.5,
         originY: 1,
         flip: true,
         scale: 0.8
      });

      flax4 = utils.addImage(this, {
         x: 700,
         y: 900,
         id: 'flax1',
         originX: 0.5,
         originY: 1,
         scale: 0.85,
         rotation: -0.1
      });


      wholeWorld = this.scene.get('world').data.get('wholeWorld')
      this.input.on('pointerup', this.animateFlax, this);

      /*** xml ***/

      xmlLoader = this.scene.get("xmlLoader");
      xmlLoader.loadThis({
         id: 'introXML',
         path: '././assets/xml/intro.xml',
         callback: this.parseXML,
         parent: this

      });


      guide = this.scene.get('guide');
      guideAnimate = this.scene.get('guideAnimate');


   }

   parseXML() {

      guide.speechBubble({
         xmlLoader: xmlLoader,
         width: 400,
         callback: _this.animateFlax,
         context: _this
      });
      next = guide.getNext();

   }
   clearInstructions() {
      let guideAnimate = this.scene.get('guideAnimate');
      guideAnimate.animateBubbleOut();

      this.input.removeAllListeners();
      //User can click skip before the speech bubble with next button has appeared
      if (next) next.removeAllListeners();


      this.scene.get('navigate').goHome();
      this.scene.stop('intro');
      this.scene.resume('world');
      //this.scene.get('navigate');
      this.scene.remove('intro');


   }

   skipIntro() {
      if (flaxGS) flaxGS.clear();
      if (worldGS) worldGS.clear();
      this.scene.get('menu').showHome();
      this.scene.get('world').setWorldPosition();
      this.scene.get('intro').clearInstructions();
      sounds.playClick();
   }


   showInstructions() {

      xmlLoader.incSpeech();
      guide.speechBubble({
         width: 400,
         xmlLoader: xmlLoader,
         callback: this.skipIntro,
         context: this
      });
      this.input.on('pointerup', this.skipIntro, this);
      //next.on('pointerup', this.skipIntro, this);

      let w = this.game.config.width;
      let h = this.game.config.height;

      arrow = this.add.image(w, h, 'arrow').setOrigin(0, 0);
      let duration = 0.8;
      worldGS = gsap.timeline({
         repeat: 1,
         repeatDelay: 0.1,
         yoyo: true,
         callbackScope: this
      });


      worldGS.to(arrow, {
            duration: duration,
            x: w / 2,
            y: h / 2 - 100,
            ease: 'sine.InOut'
         })
         .to(arrow, {
            duration: 0.1,
            rotation: '-=0.2',
            onStart: sounds.playClick

         })
         .to(wholeWorld, {
            duration: duration,

            x: '-=150*gameScale',
            y: '+=150*gameScale',
            scale: 1,
            ease: 'sine.Out',
            onStart: sounds.blipBloop,
            onStartParams: ['swipe', 0.5]
         })
         .to(arrow, {
            duration: duration,

            x: '-=150*gameScale',
            y: '+=150*gameScale',
            ease: 'sine.Out'
         }, '<')
         .to(wholeWorld, {
            duration: duration,
            delay: 0.1,
            x: '+=200*gameScale',
            y: '-=275*gameScale',
            scale: 1,
            ease: 'sine.Out',
            onStart: sounds.blipBloop,
            onStartParams: ['swipe', 0.5]
         })
         .to(arrow, {
            duration: duration,

            x: '+=200*gameScale',
            y: '-=275*gameScale',

            ease: 'sine.Out'
         }, '<');


   }

   animateFlax() {
      sounds.blipBloop('rustle', 0.5);

      //remove listeners 
      guideAnimate.animateBubbleOut();
      //this.input.on('pointerup', this.animateFlax, this);
      this.input.removeAllListeners();


      let duration = 1;
      flaxGS = gsap.timeline({
         onComplete: this.showInstructions,
         callbackScope: this

      });

      flaxGS.to(flax1, {
            duration: duration,
            x: flax1.x - 850 * gameScale,
            y: flax1.y + 10 * gameScale,
            rotation: 0.5,
            ease: "back.in"
         })
         .to(flax2, {
            duration: duration,
            x: flax2.x + 750 * gameScale,
            y: flax2.y + 100 * gameScale,
            rotation: -0.4,
            ease: "back.in",



         }, "0")
         .to(flax3, {
            duration: duration,
            x: flax3.x - 850 * gameScale,
            y: flax3.y + 10 * gameScale,
            rotation: 0.2,
            ease: "back.in",

         }, "0.1")
         .to(flax4, {
            duration: duration - 0.1,
            rotation: -0.3,
            x: flax4.x + 800 * gameScale,
            y: flax4.y + 100 * gameScale,
            ease: "back.in",
            onStart: sounds.blipBloop,
            onStartParams: ['rustle', 0.5]

         }, "0.2")
         .to(wholeWorld, {
            duration: 2,

            x: 0,
            y: 0,
            scale: 1,
            ease: 'sine.inOut'
         }, "0.2");





   }





}